var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75503 5.41645C8.09803 5.41645 7.08103 4.66945 6.01003 4.69645C4.59703 4.71445 3.30103 5.51545 2.57203 6.78445C1.10503 9.33145 2.19403 13.0935 3.62503 15.1635C4.32703 16.1715 5.15503 17.3055 6.25303 17.2695C7.30603 17.2245 7.70203 16.5855 8.98003 16.5855C10.249 16.5855 10.609 17.2695 11.725 17.2425C12.859 17.2245 13.579 16.2165 14.272 15.1995C15.073 14.0295 15.406 12.8955 15.424 12.8325C15.397 12.8235 13.219 11.9865 13.192 9.46645C13.174 7.36045 14.911 6.35245 14.992 6.30745C14.002 4.85845 12.481 4.69645 11.95 4.66045C10.564 4.55245 9.40303 5.41645 8.75503 5.41645ZM11.095 3.29245C11.68 2.59045 12.067 1.60945 11.959 0.637451C11.122 0.673451 10.114 1.19545 9.51103 1.89745C8.97103 2.51845 8.50303 3.51745 8.62903 4.47145C9.55603 4.54345 10.51 3.99445 11.095 3.29245Z",
    fill: "#3C4043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.2892a7e1bf6d4c83e710c2ba6ee2ef1a.svg";
export { ForwardRef as ReactComponent };